/* eslint-disable no-console */

import React, { useState, useEffect, useRef, useCallback } from 'react';
import styles from './styles.mod.scss';
import { useHistory } from 'react-router-dom';
import { Body } from 'scy/text';
import { accent } from 'scy/text/styles.mod.scss';
import { sendPIN, verifyPIN } from 'shared/models/api';
const DELETE = 8;

const InputPin = ({
  token,
  forcePasswordResetToken,
  email,
  setError,
  setResetPassword,
  setShowForgotPassword
}) => {
  const borderColor = '1px solid #fa6446';
  const resetBorderColor = '1px solid #e0e0e0';
  const [value, setValue] = useState('');
  const firstRef = useRef();
  const secondRef = useRef();
  const thirdRef = useRef();
  const fourthRef = useRef();
  const history = useHistory();

  useEffect(() => {
    firstRef.current = document.getElementById('1');
    secondRef.current = document.getElementById('2');
    thirdRef.current = document.getElementById('3');
    fourthRef.current = document.getElementById('4');

    firstRef.current.focus();
    sendPIN(Date.now());
  }, []);

  useEffect(() => {
    if (value.split('').length === 4) {
      setPIN().then(pin => {
        const payload = {
          pin,
          timestamp: Date.now()
        };
        verifyPIN(payload)
          .then(() => {
            forcePasswordResetToken(token, email);
            setResetPassword(true);
            setShowForgotPassword(false);
          })
          .catch(err => {
            setError(true);
            clearPIN();
            setTimeout(() => {
              setError(false);
              console.error(err);
              firstRef.current.focus();
            }, 4500);
          });
      });
    }
  }, [
    email,
    forcePasswordResetToken,
    history,
    setError,
    setPIN,
    setResetPassword,
    setShowForgotPassword,
    token,
    value
  ]);

  const clearPIN = () => {
    if (fourthRef.current.value) {
      fourthRef.current.value = '';
      fourthRef.current.style.border = resetBorderColor;
    }
    if (thirdRef.current.value) {
      thirdRef.current.value = '';
      thirdRef.current.style.border = resetBorderColor;
    }
    if (secondRef.current.value) {
      secondRef.current.value = '';
      secondRef.current.style.border = resetBorderColor;
    }
    if (firstRef.current.value) {
      firstRef.current.value = '';
      firstRef.current.style.border = resetBorderColor;
    }
    firstRef.current.focus();
    setValue('');
  };

  const setPIN = useCallback(() => {
    setValue(
      firstRef.current.value +
        secondRef.current.value +
        thirdRef.current.value +
        fourthRef.current.value
    );
    if (value.split('').length === 4) {
      return Promise.resolve(value);
    } else return Promise.reject('Please provide a 4-digit PIN');
  }, [value]);

  const resendPIN = () => {
    sendPIN(Date.now()).then(() => {
      clearPIN();
    });
  };

  const moveToNext = (e, current, next, prev) => {
    e.preventDefault();
    if (e.keyCode === DELETE) {
      if (current !== firstRef.current) {
        if (current.value) {
          current.value = '';
        }
        prev.value = '';
        prev.focus();
        current.style.border = resetBorderColor;
        prev.style.border = resetBorderColor;
      }
    }

    if (current.value) {
      current.style.border = borderColor;
      if (next) next.focus();
    }
    if (current.id == '4' && current.value) {
      setPIN()
        .then(pin => {
          verifyPIN({ pin, timestamp: Date.now() });
        })
        .catch(error => console.log(error));
    }
  };

  return (
    <>
      <div className={styles.pinInputs}>
        <input
          id="1"
          pattern="[0-9]{1}"
          type="tel"
          inputMode="numeric"
          maxLength="1"
          onKeyUp={e =>
            moveToNext(e, firstRef.current, secondRef.current, null)
          }
          ref={firstRef}
        />
        <input
          id="2"
          pattern="[0-9]{1}"
          type="tel"
          inputMode="numeric"
          maxLength="1"
          onKeyUp={e =>
            moveToNext(e, secondRef.current, thirdRef.current, firstRef.current)
          }
          ref={secondRef}
        />
        <input
          id="3"
          pattern="[0-9]{1}"
          type="tel"
          inputMode="numeric"
          maxLength="1"
          onKeyUp={e =>
            moveToNext(
              e,
              thirdRef.current,
              fourthRef.current,
              secondRef.current
            )
          }
          ref={thirdRef}
        />
        <input
          id="4"
          pattern="[0-9]{1}"
          type="tel"
          inputMode="numeric"
          maxLength="1"
          onKeyUp={e =>
            moveToNext(e, fourthRef.current, null, thirdRef.current)
          }
          ref={fourthRef}
        />
      </div>
      <Body className={accent} onClick={resendPIN}>
        Resend my PIN
      </Body>
    </>
  );
};

export default InputPin;
